//========================
$(document).ready(function() {

    //=============== Load event
   
	var RequiredAmount=2500;
	var Totlestr = $("span#total-cart-bottom").text();

	var Totleno = Totlestr.split('Rs')[1];
	var str2= Totleno.replace(",", "")
	var Totle = parseFloat(str2);
	console.log(Totle );
	console.log(RequiredAmount );
	if(RequiredAmount<=Totle){
	   console.log('go');
	   //$(' input.btn').prop('disabled', false);
	   $( ".ecomTriger" ).removeClass( "ecomMessage" )
	}else{
		console.log('block');
	   //$(' input.btn').prop('disabled', true);
	   $( ".ecomTriger" ).addClass( "ecomMessage" );
	}

    //=============== Hover event

    $(".ecomTriger").hover(function(){

			//=========  
			
			var RequiredAmount=2500;
			var Totlestr = $("span#total-cart-bottom").text();

			var Totleno = Totlestr.split('Rs')[1];
			var str2= Totleno.replace(",", "")
			var Totle = parseFloat(str2);
			console.log(Totle );
			console.log(RequiredAmount );
			if(RequiredAmount<=Totle){
			   console.log('go');
			   //$(' input.btn').prop('disabled', false);
			   //$( ".ecomTriger" ).removeClass( "ecomMessage" )
			}else{
				console.log('block');
			   //$(' input.btn').prop('disabled', true);
			   //$( ".ecomTriger" ).addClass( "ecomMessage" );
			   
			   
			    var x = document.getElementById("snackbar");
				// Add the "show" class to DIV
				x.className = "show";

				// After 3 seconds, remove the show class from DIV
				setTimeout(function(){ x.className = x.className.replace("show", ""); }, 15000);
			   
			   
			}
			
			//=========  

	}, function(){

	});


	
});


$(window).on('load', function () {
//alert("Window Loaded");
$('.background-overlay').click(function() {
console.log('www');
$("#Email").focus();
})

});

